import React from "react";
import PropTypes from "prop-types";
import AspectWrapper from "core-web/components/AspectWrapper";
import styled from "theme/libs/styled";
import ModuleMarginWrapper, { marginAfterProps } from "theme/components/wrappers/ModuleMarginWrapper";

const Wrapper = styled(AspectWrapper, {
    shouldForwardProp: (prop) => ["isFullScreen"].indexOf(prop) === -1,
})`
    max-height: ${({ isFullScreen }) => (isFullScreen ? "90%" : undefined)};

    ${({ theme }) => theme.above.tabletSm} {
        @media (min-height: 640px) {
            max-height: 90vh;
        }
    }
`;

/**
 * Used by the module system.
 * Makes sure that all contentBlocks that uses this particular setup of the AspectWrapper always maintains the same ratio.
 * @param {node} children - The child component
 * @param {string} marginAfter - Used by ModuleMarginWrapper
 */

const RATIOS = {
    small: [2, null, 3, 5],
    medium: [6 / 5, null, 2, 3],
    large: [360 / 470, 768 / 860, 1366 / 616, null, 1930 / 830],
};

const ModuleAspectWrapperLarge = ({ children, isFullScreen, marginAfter, ratioSize = "large" }) => {
    const ratio = RATIOS[ratioSize];

    return (
        <ModuleMarginWrapper marginAfter={marginAfter}>
            <Wrapper isFullScreen={isFullScreen} ratio={ratio}>
                {children}
            </Wrapper>
        </ModuleMarginWrapper>
    );
};

ModuleAspectWrapperLarge.propTypes = {
    children: PropTypes.node.isRequired,
    isFullScreen: PropTypes.bool,
    marginAfter: marginAfterProps,
};

ModuleAspectWrapperLarge.defaultProps = {
    isFullScreen: false,
    marginAfter: undefined,
};

export default ModuleAspectWrapperLarge;
